<template>
  <keep-alive>
    <!-- 
      cClass: class for all modal
      hClass: class for header
      mClass: class for body
    -->
    <Modal
      cClass="assign-product__modal"
      hClass="bg-light1 p-0 assign-product__header"
      mClass="assign-product__body"
      fClass="p-0"
      :preventBackdrop="isSubmitting || loadingRefresh"
      @cancel="cancel">
      <template #header>
        <div class="d-flex align-items-center justify-content-between assign-product__header__content px-2">
          <p class="heading-16-medium text-light-high">{{ modalTitle }}</p>
          <div class="assign-product__header-action d-flex align-items-center">
            <div class="assign-product__header-action-btn clickable" v-popover:tooltip.top="'Refresh'" @click="refreshData">
              <div class="snack-loading" v-if="loadingRefresh"><i class="icon icon-loading text-lightmode"></i></div>
              <i
                v-else
                class="icon icon-refresh text-light-high"
              ></i>
            </div>
            <div class="divider mx-1"></div>
            <div class="assign-product__header-action-btn clickable" @click="cancel">
              <i class="icon icon-small-cancel text-light-high"></i>
            </div>
          </div>
        </div>
      </template>
      <template #default>
        <template v-if="!isProductNotFound">
          <div class="assign-product__search">
            <Noti 
              class="mb-2"
              v-if="isWarningMessage"
              v-bind="messageData.attributes"
              :htmlDesc="messageData.message"
              @action="gotIt"
            >
            </Noti>
            <GpInputSearch
              :cClass="'assign-product__search-item'"
              v-model="query"
              :placeholder="searchPlaceholder[filter] || $t('newAssignment.search.placeholder.all')"
              :indicating="loadingIndicator && query.length > 0"
              has-select
              clear
              @input="delaySearch">
              <template #select>
                <div class="divider mr-2"></div>
                <BaseSelect
                  v-model="filter"
                  className="no-border base-select__new"
                  :options="filters"
                  :defaultText="$t('generals.searchBy')"
                  :defaultSelectedValue="'all'"
                  :reverseArrow="true" />
              </template>
            </GpInputSearch>
          </div>
          <div v-if="loadingIndicator && !isOnAllProduct" class="d-flex flex-column" >
            <Skeleton v-for="index in loadingSkeletonCount" customClass="mx-2" :key="index"/>
          </div>
          <div v-else-if="isNoItem" >
            <SVGNoItem :message="noItemMessage[filter] || 'No products match your search.'"/>
          </div>
          <div v-else class="assign-product__list">

            <!-- all products -->
            <div v-if="isOnAllProduct" class="assign-product__list-container">
              <div 
                class="assign-product__list-heading d-flex align-items-center justify-content-between"
                :class="isWarningMessage && (pageInfo.assignmentCount === 0 ? 'is-no-assigned-msg' : 'is-assigned-msg')"
              >
                <span class="paragraph-14-16-medium">{{$t('newAssignment.filter.all')}}</span>
              </div>
              <div 
                v-if="loadingIndicator || (query.length > 0 && loadingSearch)"
                class="d-flex flex-column px-2 pb-2">
                <Skeleton v-for="index in loadingSkeletonCount" :key="index"/>
              </div>
              <div 
                v-else
                class="px-2 pb-2"
                :class="{'pb-half mb-1': !isObserve && !isObserveQuery}"
              >
                <ProductCard  v-for="(item, index) in productData" :key="index" :info="item" :pageInfo="pageInfo" :is-submitting="isSubmitting" />
                <Observer 
                  v-if="isObserve"
                  @intersect="intersected"
                >
                  <template #customChild>
                    <Skeleton v-for="index in loadingSkeletonCount" :key="index"/>
                  </template>
                </Observer>
                <Observer
                  v-if="isObserveQuery"
                  @intersect="intersected"
                >
                  <template #customChild>
                    <Skeleton v-for="index in loadingSkeletonCount" :key="index"/>
                  </template>  
                </Observer>
              </div>
            </div>

            <!-- products by filter -->
            <div v-else class="pb-2">
              <div 
                v-for="(item, index) in productData" 
                :key="index" class="assign-product__list-container" 
                :class="{ 'no-product': checkNoProducts(item) }"
              >
                <div
                  class="assign-product__list-heading d-flex align-items-center justify-content-between"
                  :class="isWarningMessage && (pageInfo.assignmentCount === 0 ? 'is-no-assigned-msg' : 'is-assigned-msg')"
                  @click.self="handleClickItem(item)"
                >
                  <div 
                    class="d-flex align-items-center" 
                    @click="handleClickItem(item)"
                  >
                    <div class="assign-product__list-heading-icon mr-1" :class="checkNoProducts(item) ? 'text-light-disabled' : 'text-light-high'">
                      <i class="icon" :class="isExpand(item.id) ? 'icon-arrow-down' : 'icon-arrow-right'"></i>
                    </div>
                    <div 
                      v-popover:tooltip.top="item.title" 
                      class="assign-product__list-heading-name paragraph-14-16-medium text-light-high" 
                      @click="handleClickItem(item)"
                    >
                      {{ listByFilterTitle(item.title) }}
                    </div>
                  </div>
                  <span class="assign-product__list-heading-no-product mr-2" v-if="checkNoProducts(item)">{{$t('generals.noProduct')}}</span>
                  <!-- <div 
                    v-else-if="isExpand(item.id)"
                    class="assign-product__list-heading-action d-flex align-items-center" 
                  >
                    <span class="text-black4 paragraph-12-regular mr-1">{{selectLabel(item)}}</span>
                    <label
                      class="select-all__checkbox"
                      :class="[
                        { checked: (isSelectAll(item.id) && !isAssignedAllDefault(item.id)) || selectedByFilter(item).length > 0},
                        { 'unchecked-disabled': isSubmitting },
                        { 'checked-disabled': isAssignedAllDefault(item.id) },
                      ]">
                      <i
                        v-if="isSelectAll(item.id) || isAssignedAllDefault(item.id) || selectedByFilter(item).length > 0"
                        class="icon text-light1"
                        :class="isSelectAll(item.id) ? 'icon-selected' : selectedByFilter(item).length > 0 && 'icon-indeterminate'"
                      ></i>
                      <input type="checkbox" @click="selectAllProduct(item)" />
                    </label>
                  </div> -->
                </div>
                <div
                  v-if="isExpand(item.id)"
                  class="px-2"
                  :class="[
                    { 'pb-2': !isObserveProductInList(item.id) },
                    { 'assign-product__list-items': filter === 'pages' && isObserveProductInList(item.id) },
                  ]"
                >
                  <div v-if="loadingProductInList.includes(item.id)" class="d-flex flex-column" >
                    <Skeleton v-for="index in 4" :key="index"/>
                  </div>
                  <template v-else>
                    <ProductCard 
                      v-for="(product, index) in productsByFilter(item.id)"
                      :key="index"
                      :info="product"
                      :pageInfo="pageInfo"
                      :is-submitting="isSubmitting"
                    />
                    <Observer
                      class="observer"
                      v-if="isObserveProductInList(item.id)"
                      @intersect="intersectedProductByFilter(item.id)"
                    />
                  </template>
                </div>
              </div>
              <Observer 
                v-if="isObserve"
                class="observer" 
                @intersect="intersectedByFilter" />
              <Observer
                v-if="isObserveQuery"
                class="observerQuery" 
                @intersect="intersectedByFilter" />
            </div>
          </div>
        </template>
        <template v-else>
          <div class="gf_product-not-found">
            <svg width="80" height="81" viewBox="0 0 80 81" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M20.4826 62.394C29.0334 62.394 35.9652 55.4622 35.9652 46.9113C35.9652 38.3605 29.0334 31.4287 20.4826 31.4287C11.9318 31.4287 5 38.3605 5 46.9113C5 55.4622 11.9318 62.394 20.4826 62.394ZM20.4826 65.394C30.6903 65.394 38.9652 57.119 38.9652 46.9113C38.9652 36.7037 30.6903 28.4287 20.4826 28.4287C10.275 28.4287 2 36.7037 2 46.9113C2 57.119 10.275 65.394 20.4826 65.394Z"
                fill="#9E9E9E" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M43.5862 72.1362L30.8665 59.4165L32.9878 57.2952L45.7075 70.0149L43.5862 72.1362Z"
                fill="#9E9E9E" />
              <path
                d="M37.8919 20.5C37.9115 23.8133 35.2416 26.5159 31.9272 26.5355C35.2416 26.5159 37.9435 29.1865 37.963 32.5C37.9435 29.1865 40.614 26.4841 43.9272 26.4644C40.614 26.4841 37.9115 23.8133 37.8919 20.5Z"
                fill="#9E9E9E" />
              <path
                d="M10.4794 66.5C10.4908 68.4328 8.9334 70.0093 7 70.0207C8.9334 70.0093 10.5095 71.5671 10.5208 73.5C10.5095 71.5671 12.0673 69.9907 14 69.9792C12.0673 69.9907 10.4908 68.4328 10.4794 66.5Z"
                fill="#9E9E9E" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M18 53.5H75V11.5L18 11.5L18 53.5ZM18 8.5C16.3431 8.5 15 9.84315 15 11.5V53.5C15 55.1569 16.3431 56.5 18 56.5H75C76.6569 56.5 78 55.1569 78 53.5V11.5C78 9.84315 76.6569 8.5 75 8.5H18Z"
                fill="#9E9E9E" />
              <path
                d="M60.2374 17.5C62.4286 17.5 64.1992 18.1197 65.5493 19.3592C66.8994 20.5986 67.5745 22.2586 67.5745 24.3391C67.5745 26.663 66.8552 28.3894 65.4165 29.5181C63.9779 30.6248 62.0302 31.1781 59.5735 31.1781L59.4739 34.332H56.8511L56.7183 29.0866H57.6811C59.8723 29.0866 61.5876 28.7546 62.827 28.0906C64.0664 27.4266 64.6862 26.1761 64.6862 24.3391C64.6862 23.0111 64.2878 21.9598 63.491 21.1851C62.6942 20.4105 61.6208 20.0231 60.2706 20.0231C58.8984 20.0231 57.8139 20.3994 57.0171 21.1519C56.2425 21.8823 55.8551 22.8894 55.8551 24.1731H53C53 22.8451 53.2988 21.6831 53.8964 20.6871C54.494 19.669 55.335 18.8833 56.4195 18.33C57.5262 17.7767 58.7988 17.5 60.2374 17.5ZM58.1459 41.1379C57.5704 41.1379 57.0835 40.9387 56.6851 40.5403C56.2867 40.1419 56.0875 39.655 56.0875 39.0795C56.0875 38.5041 56.2867 38.0172 56.6851 37.6188C57.0835 37.2204 57.5704 37.0212 58.1459 37.0212C58.6992 37.0212 59.164 37.2204 59.5403 37.6188C59.9387 38.0172 60.1378 38.5041 60.1378 39.0795C60.1378 39.655 59.9387 40.1419 59.5403 40.5403C59.164 40.9387 58.6992 41.1379 58.1459 41.1379Z"
                fill="#9E9E9E" />
            </svg>
            <div class="gf_product-not-found__title">
              There are currently no products in your Shopify store.
            </div>
            <a
              class="gf_product-not-found__action"
              :href="urlAddProductShopify"
              target="_blank"
              >Add products to Shopify</a
            >
          </div>
        </template>
      </template>
      <template #footer>
        <div class="btn-group assign-product__footer d-flex align-items-center justify-content-end">
          <ProcessButton class="btn-default px-4" type="submit" default="btn-primary" :status.sync="btnStatus"  :disabled="isDisabledAssign && btnStatus.success == false" @click="assignProduct">
            <template #loading>{{$t('generals.apply')}}</template>
            <template #success>{{ $t("generals.success") }}</template>
            <template #error>{{ $t("generals.error") }}</template>
            <template #default>{{$t('generals.apply')}}</template>
          </ProcessButton>
        </div>
      </template>
    </Modal>
  </keep-alive>
</template>
<script>
import initProcessButton from "@/mixins/processButton.js";
import errorHandle from "@/mixins/errorHandle.js";
import ProductCard from "./components/ProductCard.vue";
import SVGNoItem from "./components/SVGNoItem.vue";
import Skeleton from "./components/Skeleton.vue";
import {mapMutations, mapActions, mapState} from "vuex";
import { GpInputSearch } from "@/core/shared/GpForms";
import Noti from "@/core/shared/base/Notification"
import Observer from "@/core/components/Observer.vue";
import { PRODUCT_FILTER } from "@/contants/productAssignment";
import { PRODUCT_ASSIGNMENT_EVENT } from "@/config/constants/trackEventIds";

export default {
  name: "AssignProductModal",
  components: {
    Skeleton,
    GpInputSearch,
    ProductCard,
    SVGNoItem,
    Observer,
    Noti
  },
  mixins: [initProcessButton(), errorHandle()],
  props: {
    pageInfo: Object,
  },
  data() {
    return {
      query: "",
      timeOut: 0,
      filter: "",
      allProducts: null,
      loadingIndicator: false,
      loadingProductInList: [],
      loadingRefresh: false,
      isSubmitting: false,
      isPublished: false,
      isMessage: false,
      makeDefaultPages: ["template-collection", "template-index", "template-product"],
      textDefault: {
        "Theme Product Template": this.$t("page.defaultShopifyTemplate"),
        "Theme Collection Template": this.$t("page.defaultShopifyTemplate"),
        "Theme Index Template": this.$t("page.defaultShopifyTemplate"),
        "Your first Homepage": this.$t("page.defaultShopifyTemplate")
      },
      previousQuery: "",
      loadingSearch: true,
    }
  },
  computed: {
    ...mapState("product", {
      product: state => state.product,
    }),
    ...mapState("account", {
      shopInfo: "shopInfo",
    }),
    ...mapState("page", {
      assignedProductList: "assignedProductList",
    }),
    messageKey() {
      if (this.isMakeDefault) {
        return 'gotPageDefaultMsg';
      }
      return this.pageInfo.is_published ? 'gotPublishedMsg' : 'gotDraftMsg';
    },
    noItemMessage() {
      return {
        [PRODUCT_FILTER.PAGES]: 'No product templates match your search.',
        [PRODUCT_FILTER.COLLECTIONS]: 'No collections match your search.',
      };
    },
    currentPageId() {
      // Clone page API return page id in camel case
      return this.pageInfo.page_id || this.pageInfo.pageId
    },
    layoutDefaultStatus() {
      return this.makeDefaultPages.includes(this.pageInfo.type) ? true : false;
    },
    isWarningMessage() {
      return this.isOriginalShopifyPage ? false : this.isMessage;
    },
    isOriginalShopifyPage() {
      return this.textDefault[this.pageInfo.title] ? true : false;
    },
    isMakeDefault () {
      if (!this.layoutDefaultStatus) return false;
      return this.pageInfo.published;
    },
    isObserve() {
      return !this.isFetchedAll && this.query.length == 0 && this.loadingIndicator === false;
    },
    isObserveQuery() {
      return !this.isFetchedAllQuery && this.query.length > 0 && this.loadingSearch === false;
    },
    isFetchedAll() {
      if (this.filter === '') return  this.product.all.fetched;
      return this.product[this.filter].fetched;
    },
    isFetchedAllQuery() {
      if (this.filter === '') return  this.product.all.queryFetched;
      return this.product[this.filter].queryFetched;
    },
    modalTitle() {
      if (this.isMakeDefault) {
        return this.$t('newAssignment.modal.titlePageDefault');
      }
      return this.$t('newAssignment.modal.title');
    },
    isOnAllProduct() {
      return this.filter === PRODUCT_FILTER.ALL || this.filter === ''
    },
    productData() {
      const filter = this.filter ===  '' ? PRODUCT_FILTER.ALL : this.filter;
      if (this.query.length !== 0) {
        return this.product[filter].queryList;
      } 
      return this.product[filter].list
    },
    isNoItem() {
      const fetched = this.query.length > 0 ? this.isFetchedAllQuery : this.isFetchedAll;
      return  fetched && !this.productData.length;
    },
    searchPlaceholder() {
      return {
        [PRODUCT_FILTER.PAGES]: this.$t('newAssignment.search.placeholder.templates'),
        [PRODUCT_FILTER.COLLECTIONS]: this.$t('newAssignment.search.placeholder.collections')
      }
    },
    filters() {
      return [
        {
          value: PRODUCT_FILTER.ALL,
          text: this.$t('newAssignment.filter.all')
        },
        {
          value: PRODUCT_FILTER.COLLECTIONS,
          text: this.$t('newAssignment.filter.collections')
        },
        {
          value: PRODUCT_FILTER.PAGES,
          text: this.$t('newAssignment.filter.pages')
        },
      ];
    },
    isDisabledAssign() {
      const initialList = this.product.assignment.assigned;
      const selectedList = this.product.assignment.selected;
      if (initialList.length === selectedList.length) {
        return initialList.every((element) => {
          return selectedList.includes(element);
        });
      }
      return false;
    },
    loadingSkeletonCount() {
      const SKELETON_ITEMS = 5;
      return this.isWarningMessage ? SKELETON_ITEMS - 2 : SKELETON_ITEMS;
    },
    selectFilterEventId() {
      return {
        [PRODUCT_FILTER.PAGES]: PRODUCT_ASSIGNMENT_EVENT.SELECT_PRODUCT_TEMPLATES,
        [PRODUCT_FILTER.COLLECTIONS]: PRODUCT_ASSIGNMENT_EVENT.SELECT_SHOPIFY_COLLECTIONS
      }
    },
    messageData() {
      return this.dynamicMessageData[this.messageKey];
    },
    dynamicMessageData() {
      return {
        gotNoAssignedMsg: {
          attributes: {
            type: 'infor',
            actionTitle: 'Got it',
            isInline: true,
            isCloseOnAction: true,
          },
          message: this.$t('newAssignment.message.noAssignedTemplate'),
        },
        gotDraftMsg: {
          attributes: {
            type: 'infor',
            actionTitle: 'Got it',
            isInlineAction: true,
            isCloseOnAction: true,
          },
          message: this.$t('newAssignment.message.draftTemplate'),
        },
        gotPublishedMsg: {
          attributes: {
            type: 'warn',
            actionTitle: 'Got it',
            isInlineAction: true,
            isCloseOnAction: true,
          },
          message: this.$t('newAssignment.message.publishedTemplate'),
        },
        gotPageDefaultMsg: {
          attributes: {
            type: 'infor',
            actionTitle: 'Got it',
            isInlineAction: true,
            isCloseOnAction: true,
          },
          message: this.$t('newAssignment.message.gotPageDefaultMsg'),
        }
      }
    },
    isProductNotFound() {
      return (
        this.product[PRODUCT_FILTER.ALL].list.length === 0 &&
        !this.loadingIndicator &&
        !this.isObserve &&
        !this.isObserveQuery
      );
    },
    urlAddProductShopify() {
      return `https://${this.shopInfo.shopifyDomain}/admin/products`;
    },
  },
  watch: {
    filter(val) {
      this.trackEvent({
        event_id: this.selectFilterEventId[val] || PRODUCT_ASSIGNMENT_EVENT.SELECT_ALL_PRODUCTS,
        properties: {
          page_type: 'productpages',
          template_page_id: this.pageInfo.id,
          filter: this.filter ===  '' ? PRODUCT_FILTER.ALL : this.filter
        }
      });
      this.query = '';
      this.setSearchBy(val);
      this.resetScroll();
      this.resetSearch();
      if (this.isFetchedAll || this.product[val === '' ? PRODUCT_FILTER.ALL : val].list.length !== 0) return;
      if (val === PRODUCT_FILTER.ALL || val === '') {
        return this.getProductList({ isFistLoad: true });
      }
      this.getListOfFilter();
    },
    query(newVal, oldVal) {
      this.resetScroll();
      this.resetSearch();
      if (oldVal.length > 0 && newVal.length === 0) {
        this.previousQuery = "";
      }
      this.loadingIndicator = this.query.length != 0;
    },
  },
  created () {
    this.setSearchBy(this.filter);
    const key = this.messageKey;
    const listItem = localStorage.getItem(key);
    this.isMessage = !listItem?.includes(this.currentPageId);
  },
  mounted () {
    this.isPublished = this.pageInfo.is_published;
    if (!this.product.pageId) {
      this.setPageId(this.currentPageId);
      this.getProductList({isFistLoad: true});
    } else {
      const isOpenInNewTemplate = this.product.pageId != this.currentPageId;
      if (isOpenInNewTemplate) {
        this.resetProductData();
        this.setPageId(this.currentPageId);
        this.getProductList({isFistLoad: true});
      } else if (!this.isFetchedAll && this.product[PRODUCT_FILTER.ALL].list.length === 0) {
        this.getProductList({isFistLoad: true});
      }
    }
  },
  methods: {
    ...mapMutations("product", {
      setExpand: "SET_EXPAND_LIST",
      setSearchBy: "SET_SEARCH_BY",
      setPageId: "SET_PAGE_ID",
      setSelectAll: "SET_SELECT_ALL",
      resetSearch: "RESET_SEARCH_RESULT",
      resetProductData: "RESET_PRODUCT_DATA",
      refreshProductData: "REFRESH_PRODUCT_DATA",
      refreshProductQueryData: "REFRESH_PRODUCT_QUERY_DATA",
      resetSelectProduct: "RESET_SELECT_PRODUCT",
      resetSelectByFilter: "RESET_SELECT_BY_FILTER",
      setAssignedProduct: "SET_ASSIGNED_PRODUCT",
    }),
    ...mapMutations("page", {
      resetFetchedPage: "RESET_FETCHED_PAGE",
    }),
    ...mapActions("common", {
      trackEvent: "trackEvent"
    }),
    ...mapActions("product", {
      getProducts: "getProducts",
      getListByFilter: "getListByFilter",
      getProductsByFilter: "getProductsByFilter",
      updatePageAssignment: "updatePageAssignment",
    }),
    ...mapActions("page", {
      updateAssigmentCount: "updateAssigmentCount"
    }),
    gotIt() {
      const pageId = this.currentPageId;
      const key = this.messageKey;
      const listItem = localStorage.getItem(key);
      const list = listItem ? JSON.parse(listItem) : [];
      if (!list.includes(pageId)) {
        list.push(pageId);
      }
      localStorage.setItem(key, JSON.stringify(list));
      this.isMessage = false;
    },
    selectedByFilter(item) {
      const selectedIds = this.product.assignment.selected;
      const productsByFilterIds = new Set(this.productsByFilter(item.id)?.map(product => product.id));
      return selectedIds.filter(id => productsByFilterIds.has(id))
    },
    selectLabel(item) {
      const selectedCount = this.selectedByFilter(item).length;
      if(selectedCount > 0 && !this.isSelectAll(item.id)) {
        const count = `${selectedCount}/${this.productsByFilter(item.id).length}`;
        return this.$t('generals.selectPartially', { count: count });
      } else {
        return this.$tc('generals.selectALL');
      }
    },
    selectAllProduct(item) {
      if (this.isSubmitting || this.loadingProductInList.includes(item.id)) return;
      const pageId = this.currentPageId;
      const productList = this.productsByFilter(item.id);
      const selectedByFilter = this.selectedByFilter(item);
      
      if (selectedByFilter.length > 0 && !this.isSelectAll(item.id)) { 
        return this.resetSelectByFilter(selectedByFilter);
      }

      if (this.isMakeDefault) {
        const filterList = productList.filter(
          (item) => !item.assigned_page_ids.includes(pageId) && item.assigned_page_ids.length > 0,
        );
        return this.setSelectAll(filterList);
      }
      this.setSelectAll(productList);
    },
    disableLoading() {
      this.loadingIndicator = false;
      if (this.loadingRefresh) {
        const refreshTimeOut = 5000;
        setTimeout(() => {
          this.loadingRefresh = false;
        }, refreshTimeOut);
      }
    },
    checkFetchData(filter) {
      const { fetched, queryFetched } = this.product[filter];
      if ((this.query?.length > 0 && queryFetched) || (this.query?.length === 0 && fetched)) {
        return this.disableLoading();
      }
    },
    async getProductList(params) {
      if (params?.isFistLoad) this.loadingIndicator = true;
      this.checkFetchData(PRODUCT_FILTER.ALL);
      await this.getProducts({ 
        query: this.query.toLowerCase().trim() || '', 
        page_id: this.currentPageId,
        refresh: params?.isRefresh || false,
        changeQuery: params?.isChangeQuery || false
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
      })
      .finally(() => {
        this.disableLoading();
      });
    },
    async getListOfFilter(params) {
      const { list, queryList } = this.product[this.filter];
      if (list.length == 0 || (this.query.length > 0 && queryList.length == 0)) this.loadingIndicator = true;

      this.checkFetchData(this.filter);
      await this.getListByFilter({ 
        query: this.query.toLowerCase().trim() || '', 
        page_id: this.currentPageId, 
        filter: this.filter, 
        refresh: params?.isRefresh || false,
        changeQuery: params?.isChangeQuery || false 
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
      })
      .finally(() => {
        this.disableLoading();
      });
    },
    delaySearch() {
      const q = this.query?.toLowerCase().trim() || '';
      if (this.timeOut) clearTimeout(this.timeOut);
      this.timeOut = setTimeout(async () => {
        const isNotChangeQuery = q === this.previousQuery;
        if (q.length == 0 || isNotChangeQuery) return;
        this.previousQuery = q;
        if (this.isOnAllProduct) {
          this.resetSearch();
          await this.getProductList({isFistLoad: true, isChangeQuery: true});
          this.loadingSearch = false;
          return;
        }
        this.getListOfFilter();
      }, 500);
    },
    loadAssignmentCount() {
      this.resetFetchedPage('productpages');
      this.updateAssigmentCount({ type: 'productpages' });
    },
    async refreshData() {
      if (this.loadingRefresh || this.loadingIndicator || this.isSubmitting) return;
      this.resetScroll();
      this.loadingRefresh = true;
      this.query.length > 0 ? this.refreshProductQueryData() : this.refreshProductData();
      if (this.isOnAllProduct) {
        await this.getProductList({isFistLoad: true, isRefresh: true});
      } else {
        await this.getListOfFilter({isFistLoad: true, isRefresh: true, isChangeQuery: true});
      }
      this.loadAssignmentCount();
    },
    cancel() {
      if (this.isSubmitting) return;
      this.resetSelectProduct();
      this.$emit("close");
    },
    intersected() {
      this.getProductList();
    },
    intersectedByFilter() {
      this.getListOfFilter();
    },
    intersectedProductByFilter(id) {
      this.getProductsByFilter({ id: id, filter: this.filter });
    },
    isObserveProductInList(id) {
      return (
        this.filter === PRODUCT_FILTER.PAGES &&
        !this.product[this.filter].products.find((item) => item.filter_id === id)?.fetched
      );
    },
    resetScroll() {
      const container = document.querySelector(".assign-product__body");
      if(container && container.scrollTop !== 0) container.scrollTop = 0;
    },
    isExpand(id) {
      return this.product[this.filter].expandedList.includes(id);
    },
    isSelectAll(filterId) {
      const pageId = this.currentPageId;
      const productList = this.productsByFilter(filterId);
      if (!productList || productList?.length == 0) return;
      if (this.isMakeDefault) {
        return productList
          .filter((item) => !item.assigned_page_ids.includes(pageId) && item.assigned_page_ids.length != 0)
          .every((item) => this.product.assignment.selected.includes(item.id));
      } else {
        return productList.every((item) => this.product.assignment.selected.includes(item.id));
      }
    },
    isAssignedAllDefault(filterId) {
      const pageId = this.currentPageId;
      const productList = this.productsByFilter(filterId);
      if (!productList || productList?.length == 0) return;
      return productList.every(
        (item) => (item.assigned_page_ids.includes(pageId) || item.assigned_page_ids.length == 0) && this.isMakeDefault,
      );
    },
    productsByFilter(id) {
      const productsByFilterList = this.product[this.filter].products;
      const productItem = productsByFilterList.find(item => item.filter_id == id);
      return productItem?.list;
    },
    handleClickItem(item) {
      if (item.products_count === 0 && !item?.published) return;
      this.setExpand({ filter: this.filter, id: item.id });

      const productsByFilterList = this.product[this.filter].products;
      const productItem = productsByFilterList.find(x => x.filter_id == item.id);
      if (productsByFilterList.length !== 0 && productItem) return;
      
      this.loadingProductInList.push(item.id);
      this.getProductsByFilter({ id: item.id, filter: this.filter })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.error(err);
        })
        .finally(() => {
          this.loadingProductInList.splice(
            this.loadingProductInList.indexOf(item.id), 1
          );
        });
    },
    trackEventConfirm() {
      this.trackEvent({
        event_id: PRODUCT_ASSIGNMENT_EVENT.CONFIRM_ASSIGNMENT,
        properties: {
          filter: this.filter ===  '' ? PRODUCT_FILTER.ALL : this.filter,
          page_type: 'productpages',
          template_page_id: this.pageInfo.id
          // select_all: this.isUseSelectAll
        }
      });
    },
    async assignProduct() {
      if (this.isDisabledAssign || this.isSubmitting) return;
      this.trackEventConfirm();
      this.activeLoading();
      this.isSubmitting = true;
      try {
        this.gSnackbarCommit({
          message: this.$t("status.processing"),
          type: "loading"
        });
        const isUseSocket = window._webSocket && window._webSocket.connection.readyState === 1;
        const isPublished = this.pageInfo.is_published;
        const res = await this.updatePageAssignment({ pageId: this.currentPageId });
        if (!res.assigned && isUseSocket && isPublished) {
          window._webSocket.onmessage('publish_page_assignments_processing', (data) => {
            if (data.status == 'success') {
              this.onSuccessAssignedProduct();
              window._webSocket.offmessage('publish_page_assignments_processing');
            } else {
              this.gSnackbarCommit({
                message: data.message || 'Error',
                type: "error"
              });
              this.isSubmitting = false;
              this.resetStatus();
            }
          });
        } else {
          this.onSuccessAssignedProduct();
        }
      } catch (error) {
        const message = error?.response?.data?.message || "Error";

        this.gSnackbarCommit({
          message: this.getErrorMessage(message),
          type: "error"
        });

        this.activeError();
        this.resetStatus();
      }
    },
    onSuccessAssignedProduct () {
      this.isSubmitting = false
      setTimeout(() => {
        this.activeSuccess();
        this.gSnackbarCommit({
            message: `${this.$t("status.success")} ${this.$t("generals.assigned").toLowerCase()} ${this.$tc("page.productLower", 1)}`,
            type: "success"
          });
      }, 1000);
      setTimeout(() => {
        this.resetStatus();
        this.loadAssignmentCount();
        this.resetProductData();
        if (this.filter === PRODUCT_FILTER.ALL) {
          this.getProductList({ isFistLoad: true });
        }
        this.query = '';
        this.filter = PRODUCT_FILTER.ALL;
        this.setPageId(this.currentPageId);
        if (!this.pageInfo.is_published) this.isPublished = false;
      }, 3000);
    },
    listByFilterTitle(title) {
      const defaultPageTitle = {
        "Theme Product Template": this.$t("page.defaultShopifyTemplate"),
        "Theme Collection Template": this.$t("page.defaultShopifyTemplate"),
        "Theme Index Template": this.$t("page.defaultShopifyTemplate"),
        "Your first Homepage": this.$t("page.defaultShopifyTemplate")
      };
      return defaultPageTitle[title] ?? title;
    },
    checkNoProducts(item) {
      return item.products_count === 0 && !item?.published;
    },
  },
};
</script>

<style lang="scss">
  .observer {
  height: 10px;
  border-radius: 3px 3px 0px 0px;
  animation: skeleton-loading 1s linear infinite alternate;
}
.observerQuery {
  height: 10px;
  border-radius: 3px 3px 0px 0px;
  animation: skeleton-loading 1s linear infinite alternate;
}
.divider {
  border-left: 1px solid $neutral7;
  height: 16px;
}
.assign-product {
    &__modal {
      width: 600px;
    }  
    &__loader {
    position: relative;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  &__body {
    position: relative;
    height: 563px;
    background-color: $light2;
  }
  &__search {
    position: sticky;
    z-index: 3;
    top: 0;
    left: 0;
    padding: 16px;
    background-color: $light2;
  }
  &__list {
    margin: 0 16px;
    &-container {
      background-color: $light1;
      border-radius: $radius;
      position: relative;
      cursor: pointer;
      &.no-product {
        cursor: not-allowed;
      }
    }
    &-container:not(:nth-child(1)) {
      margin-top: 12px;
    }
    &-heading {
      position: sticky;
      padding: 18px 16px;
      background-color: $light1;
      border-radius: 3px 3px 0 0;
      z-index: 2;
      top: 164px;
      &.is-no-assigned-msg {
        top: 144px;
      }
      &:not(.is-no-assigned-msg):not(.is-assigned-msg) {
        top: 71px;
      }
      span {
        max-width: 400px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      &-icon {
        height: 16px;
        width: 16px;
        @include flex-center;
      }
      &-name {
        max-width: 390px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      &-no-product {
        font-size: 12px;
        line-height: 150%;
        font-style: italic;
        color: $dark6;
      }
    }
    &-checkbox {
      margin-right: 17.25px;
    }
    &-items {
      overflow-y: auto;
      overscroll-behavior: contain;
      max-height: 350px;
    }
  }
  &__header {
    height: 55px;
    border-radius: 3px 3px 0px 0px;
    &__content {
      height: 100%;
      > p {
        max-width: 480px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    &-action {
      &-btn {
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 3px;
        &:hover {
          background-color: $textDarkModeHigh;
        }
        > i {
          font-size: 16px;
        }
      }
    }
  }
  &__footer {
    height: 64px;
    padding: 12px 16px;
    border-radius: 0px 0px 3px 3px;
    background-color: #ffffff;
    border-top: solid 1px $light3;

    .btn-default {
      color: $light1;
      line-height: 16px !important;

      &:disabled {
        color: map-get($text-light-mode, 'disabled');
        background: map-get($hybrid-shade-light, '300');
      }
    }
  }
}

.select-all__checkbox {
  width: 17.5px;
  height: 17.5px;
  margin-right: 17.25px;
  outline: 2px solid transparent;
  background-color: #ffffff;
  border-radius: 3px;
  padding-bottom: 0px;
  position: relative;
  @include flex-center;
  @include trans-all;
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  .icon {
    height: inherit;
  }
  .icon::before {
    font-size: 10.83px !important;
  }
  &.checked-disabled {
    background: $neutral7;
    .icon {
      color: $light3;
    }
  }
  &:before {
    content: '';
    background-color: rgba(0, 0, 0, 0.05);
    border-radius: 3px;
    position: absolute;
    width: 28px;
    height: 28px;
    opacity: 0;
    @include trans-all;
  }
  &:not(.checked):not(.checked-disabled):not(.unchecked-disabled):hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
  &:not(.checked-disabled) {
    border: solid 1.25px $dark6;
  }
  &:not(.checked-disabled):not(.unchecked-disabled):hover:before {
    opacity: 1;
    cursor: pointer;
  }

  &.checked {
    background: $mono3;
    border-color: $mono3;

    &:hover {
      outline-color: rgba(26, 148, 255, 0.2);
    }
  }
}

.snack-loading {
  font-size: 16px;
  width: 16px;
  animation: spin 1s linear infinite;
}

.gf_product-not-found {
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
  display: flex;
  &__title {
    line-height: 150%;
    font-weight: 500;
    font-size: 1rem;
    margin-top: 8px;
    color: map-get($text-light-mode, "low-contrast");
  }
  &__action {
    line-height: 150%;
    font-weight: 500;
    font-size: 0.875rem;
    margin-top: 4px;
    color: map-get($primary-blue, "300"); 
    &:hover {
      color: map-get($primary-blue, "325"); 
      text-decoration: underline;
    }
  }
}

@keyframes skeleton-loading {
  0% {
    background-color: hsl(0, 0%, 80%);
  }
  100% {
    background-color: hsl(0, 0%, 89%);
  }
}
</style>
